import React, { useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'

function ModalCancelarCte({ cte, isVisible, onCancel, onSave, onError }) {
  if (!cte) return null
  // Vars

  // Hooks
  const [justificativa, setJustificativa] = useState(cte.justificativa ? cte.justificativa : '')

  // Events
  const onBtnSalvarClicked = async () => {
    const texto = justificativa.trim()
    if (texto.length < 15 || texto.length > 255) {
      onError('A justificativa deve ter entre 15 e 255 caracteres')
      return
    }
    onSave({ ...cte, justificativa: texto })
  }

  // Render
  return (
    <CustomModal header="Cancelar CTe" isVisible={isVisible} onClose={onCancel}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Justificativa :"
            marginTop={10}
            value={justificativa}
            onChange={value => setJustificativa(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalCancelarCte
